export default "__VITE_ASSET__BxezFgEm__"